import {
  EventModel,
  EventModelAttributes,
  EventCollection,
} from 'src/models/EventModel';
import {
  EventAdapterInteface,
  ListEventsInput as BaseListEventsInput,
} from 'src/adapter/EventAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListEventsInput = BaseListEventsInput;
export class EventApiClass {
  adapter: EventAdapterInteface;
  constructor(adapter: EventAdapterInteface) {
    this.adapter = adapter;
  }
  async listEvents(
    conditions: ListEventsInput
  ): Promise<{ total: number; events: EventCollection }> {
    try {
      conditions?.page;
      const res = await this.adapter.listEvents({
        page: conditions.page,
        limit: conditions.limit,
        filter: conditions.filter,
      });
      return {
        total: res.total,
        events: res.events.map(
          (event: EventModelAttributes) => new EventModel(event)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getEvent(id: string): Promise<EventModel> {
    try {
      const event = await this.adapter.getEvent(id);
      return new EventModel(event);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
